import { abbrFloatingNumberFilter, abbrNumberFilter } from "app/filters/ngFilters";

import { DOLLAR_PREFIX } from "../constants/index";

const addUnitAtTheEnd =
    (unit = "") =>
    (value: number | string) => {
        return `${value}${unit}`;
    };

const addPercentAtTheEnd = addUnitAtTheEnd("%");

export const formatNumber = (value: number | string): string => abbrNumberFilter()(value);

export const formatFloatingNumber = (value: number | string): string | number => abbrFloatingNumberFilter()(value);

export const formatPercent = (value: number): string => addPercentAtTheEnd(Math.floor(value * 100));

export const formatMoney = (value: number | string): string => `${DOLLAR_PREFIX}${abbrNumberFilter()(value)}`;

export const formatTime = (value: number): string => {
    if (value < 60) {
        return addUnitAtTheEnd("s")(value);
    }

    const minutes = Math.round((value / 60) * 100) / 100;
    return addUnitAtTheEnd("m")(minutes);
};
